/**
 * Side Door return from Plot notebook remounts Discovery talk.
 * #947 must not drop the only copy of the sitting just because Jump
 * Start / Nudge bumped the load generation while GET was still out.
 * Nudge Skip only PATCHes votes — it does not clear the thread.
 */

export function shouldApplyChatMessageLoad({
  generation,
  currentGeneration,
  requestedSessionId,
  currentSessionId,
  incomingMessages,
} = {}) {
  if (!requestedSessionId || requestedSessionId !== currentSessionId) {
    return false;
  }
  const incoming = Array.isArray(incomingMessages) ? incomingMessages : [];
  if (generation === currentGeneration) return true;
  // Stale empty GET must never wipe a live thread (#947).
  if (incoming.length === 0) return false;
  // Stale GET with history: still apply. Spur Creek Two Step merge
  // keeps any Jump Start / send rows already on screen.
  return true;
}

/**
 * Server tail is the sitting. Keep local rows the GET does not have
 * yet (temps, streaming, a just-landed turn the GET missed).
 * Overlapping ids keep the local row so a live stream is not rolled
 * back to an older GET body.
 */
function isStandIn(row) {
  if (!row) return false;
  if (row.streaming) return true;
  const id = String(row.id || '');
  return id.startsWith('temp-') || id.startsWith('streaming-');
}

function sameSpokenTurn(left, right) {
  if (!left || !right) return false;
  const leftSpeaker = String(left.speaker || left.role || '');
  const rightSpeaker = String(right.speaker || right.role || '');
  if (leftSpeaker !== rightSpeaker) return false;
  const leftText = String(left.content || '').trim();
  const rightText = String(right.content || '').trim();
  return leftText.length > 0 && leftText === rightText;
}

export function mergeServerThread(localMessages, serverMessages) {
  const server = Array.isArray(serverMessages) ? serverMessages : [];
  const local = Array.isArray(localMessages) ? localMessages : [];
  if (!local.length) return server;
  const localById = new Map(local.map((row) => [row.id, row]));
  const seen = new Set();
  const out = [];
  for (const row of server) {
    if (!row?.id) continue;
    seen.add(row.id);
    out.push(localById.get(row.id) || row);
  }
  for (const row of local) {
    if (!row?.id || seen.has(row.id)) continue;
    if (isStandIn(row) && server.some((item) => sameSpokenTurn(item, row))) continue;
    out.push(row);
  }
  return out;
}
